<template lang="html">
    <div id="TutoringReport"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div style="width: 100%;height: 100%;">

            <el-row style="height: 40px;line-height: 40px;margin-top: 20px">
                <el-col :span="6">
                    <span>月份</span>
<!--                    <el-date-picker-->
<!--                            v-model="date"-->
<!--                            style="width: 150px"-->
<!--                            format="yyyy年MM月"-->
<!--                            value-format="yyyy-MM"-->
<!--                            type="month"-->
<!--                            placeholder="选择月">-->
<!--                    </el-date-picker>-->
                    <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                </el-col>

            </el-row>

            <el-row style="margin-top:20px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button size="small" style="background: #4EC880;border:none;color: #fff" @click.stop="searchWeekList">查询</el-button>
                <el-button size="small" style="background: #D0021B;border:none;color: #fff" @click.stop="ResetClick">重置</el-button>
                <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDataClick">
                    导出数据
                </el-button>
            </el-row>
            <el-row>
                <el-col>
                    <p style="font-size: 21px;color: #000;margin-bottom: 5px">{{yearsDate}}
                    <span style="color: #FF9901;font-size: 16px;">协访总时长{{sumDate.toFixed(2)}}小时</span>
                    </p>
                </el-col>
            </el-row>


            <el-row >
                <el-col :span="11" style="margin-top:40px;">
                    <el-col :span="5">
                        <p style="font-size: 14px;color: #909399;margin:0;margin-top:25px;">辖区客户数</p>
                        <p style="font-size: 14px;color: #909399;margin:0;margin-top:38px">覆盖客户数</p>
                    </el-col>
                    <el-col :span="12">
                        <p style="width: calc(100% - 50px);display: inline-block;margin:0;margin-top:20px;">
                            <el-progress :text-inside="true" :show-text="false" color="#419DE7" stroke-linecap="butt" :stroke-width="20" :percentage="territoryPercentage"></el-progress>
                        </p>
                        <span style="color:#FF9901;float: right;margin-top:20px;">{{sumNum}}家</span>
                        <p style="margin:0;float: right;font-size: 9px;color: #4A90E2;margin-right: 50px;">机构{{insNum}}家 | 门店{{stoNum}}家 | 经销商{{disNum}}家</p>
                        <p style="width: calc(100% - 50px);display: inline-block;margin:0;margin-top:20px">
                            <el-progress :text-inside="true" :show-text="false" color="#419DE7" stroke-linecap="butt" :stroke-width="20" :percentage="customerPercentage"></el-progress>
                        </p>
                        <span style="color:#FF9901;float: right;margin:0;margin-top:20px">{{customerNum}}家</span>
                    </el-col>
                    <el-col :span="6" style="padding-left: 30px">
                        <div id="coverEchart" style="width:100%;height: 120px;"></div>
                    </el-col>
                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto"></div>
                </el-col>
                <el-col :span="12" style="margin-top:0px;">
                    <el-col :span="12">
                        <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
                        <div id="main1" style="width:100%;height: 180px;margin-left:35%"></div>
                    </el-col>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">协访客户</p>
                </el-col>
                <el-col :span="12">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">协访次数</p>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                    <el-table
                            :data="tableArray"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="activity_date"
                                label="日期"
                                sortable
                                >
                        </el-table-column>
                        <el-table-column
                                prop="coach_name"
                                sortable
                                label="协访人">
                        </el-table-column>
                        <el-table-column
                                prop="coachee_name"
                                sortable
                                label="被协访人">
                        </el-table-column>
                        <el-table-column
                                prop="category_type"
                                sortable
                                label="协访类型">
                        </el-table-column>
                        <el-table-column
                                prop="clients"
                                sortable
                                label="协访客户数">
                        </el-table-column>
                        <el-table-column
                                prop="in_field"
                                sortable
                                label="协访时长">
                        </el-table-column>
                        <el-table-column
                                prop="completed"
                                sortable
                                label="协访评估已完成"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                sortable
                                label="计划内协访">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-col style="font-size: 12px;color: #87909A;margin: 5px 0">
                    * 协访客户数为协访人和被协访人在协访当天都完成签到的客户统计
                </el-col>
                <el-col style="font-size: 12px;color: #87909A;">
                    ** 协访时长为协访人和被协访人在协访当天签到记录的重合时间段累计
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>

    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import moment from 'moment'
    import check from '../../../assets/images/check.png'
    import reportMonth from './reportMonth'
    export default {
        name: "TutoringReport",
        data() {
            return {
                date:'',
                // date: new Date(),
                conditionsForm:[],
                tableArray: [],
                isManager:this.$store.getters.getUser.role !== 'staff',
                territory_id:'',
                insNum:0,
                disNum:0,
                stoNum:0,
                sumNum:0,
                customerNum:0,
                customerPercentage:0,
                coverEchart:'',
                sumDate:0,
                planNum:0,
                realNum:0,
                assessmentNum:0,
                territoryPercentage:0,
                yearsDate:''
            }
        },
        components: {
            reportMonth
        },
        created () {
            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年MM月')

        },
        mounted () {
            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年MM月')
            window.onresize = () => {
                this.coverEchart.resize()

            }

            // this.getVisitCoverStaffTerritory().then(()=>{
            //
            // })
            this.getData()

        },
        updated(){
        },
        methods: {
            handleSelectInput(j){
                this.date = j
            },
            // async getVisitCoverStaffTerritory(){
            //     try {
            //         let user = this.$store.getters.getUser
            //         let data = {
            //             tenant_id:user.tenant_id,
            //             user_id : user.user_id,
            //             month : this.GLOBAL.date,
            //         }
            //         await http.post('/crm/web/report/tabledata/getVisitCoverStaffTerritory',data).then(res=>{
            //             if(res.success){
            //                 this.territory_id = res.data
            //                 console.log(res.data)
            //
            //             }
            //         })
            //     }  catch (e) {
            //
            //     }
            // },
            async getData(){
              debugger
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                        user_id : user.user_id,
                        month : this.GLOBAL.date,
                        role:user.role
                    }
                    let self = this
                    await http.post('/crm/web/report/tabledata/getTutoringHelpStatistical',data).then(res=>{
                        if(res.success){
                            console.log(res.data)
                          self.realNum =0
                          self.planNum = 0
                          self.assessmentNum=0
                          self.insNum = res.data.institutionArray.length
                          self.disNum = res.data.distributorArray.length
                          self.stoNum = res.data.storeArray.length
                          self.sumNum = self.insNum + self.stoNum + self.disNum

                          self.tableArray = res.data.tableArray
                          debugger
                          self.customerNum = res.data.count
                          debugger
                          self.sumDate = 0
                            for(let i = 0;i<self.tableArray.length;i++){
                                // if(this.tableArray[i].clients){
                                //     this.customerNum += Number(this.tableArray[i].clients)
                                // }else{
                                //     this.customerNum += 0
                                // }
                                if(this.tableArray[i].in_field){
                                  self.sumDate+=parseFloat((Number(self.tableArray[i].in_field)/60).toFixed(2))
                                }else{
                                  self.sumDate+=0
                                }
                            }
                          self.assessmentNum = 0
                          self.planNum = 0
                          self.tableArray.forEach(item=>{
                                if(item.completed == 'T'){
                                    item.completed = '1份'
                                    this.assessmentNum +=1
                                }else{
                                    item.completed = '0份'
                                }
                                if(item.clients){

                                }else{
                                    item.clients=0
                                }
                                this.planNum += parseFloat(item.clients)
                                if(item.status == 'ACTIVE'){
                                    item.status = '否'
                                }else{
                                    item.status = '是'
                                    this.realNum += 1
                                }
                                if(item.in_field){
                                    item.in_field = (Number(item.in_field)/60).toFixed(2)+'小时'
                                }else{
                                    item.in_field = 0+'小时'
                                }

                            })
                            // if(this.sumNum==0){
                            //     let tag=document.getElementsByClassName('el-progress-bar__inner')
                            //     tag[0].style.backgroundColor="#909090"
                            // }
                            // if(this.customerNum==0||this.sumNum==0){
                            //     let tag=document.getElementsByClassName('el-progress-bar__outer')
                            //     tag[1].style.backgroundColor="#909090"
                            // }
                            if(self.insNum!=0||self.disNum!=0||self.stoNum!=0){
                              self.territoryPercentage=100
                            }
                          self.customerPercentage = (self.customerNum/self.sumNum).toFixed(2)*100
                        this.init()
                            loading.close()
                        }
                    })
                }  catch (e) {
                    loading.close()
                }
            },
            init(){
                    this.coverEchart=this.$echarts.init(document.getElementById('coverEchart'))
                    this.coverEchart.setOption({
                        color:['#419DE7', '#d9ebfa'],
                        title:{
                            text:'客户覆盖率',
                            textStyle: {
                                color:'#909399',
                                fontWeight: 100,
                                fontSize: 14
                            },
                            x:'center',
                            y:'bottom'
                        },
                        series: [
                            {
                                type: 'pie',
                                center: ['50%', '40%'],
                                radius: ['70%', '80%'],
                                avoidLabelOverlap: false,
                                hoverAnimation: false,
                                label: {
                                    normal: {
                                        show: true,
                                        position: 'center',
                                        formatter: '{w|{d}}{t|%}',
                                        rich:{
                                            w:{
                                                fontSize:16,
                                                fontWeight:'bold'
                                            },
                                            t:{
                                                fontSize:14,

                                            }
                                        }
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        show: false
                                    }
                                },
                                data:[
                                    {
                                        value: this.customerNum,
                                    },
                                    {
                                        value: this.sumNum-this.customerNum,
                                        label: {
                                            normal: {
                                                show: false
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                    this.bookCategoryChart =this.$echarts.init(document.getElementById('main1'));
                    this.bookCategoryChart.setOption({
                    color: ['#3398DB'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: ['计划', '实际', '完成评估'],
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine:{
                                lineStyle:{
                                    color:'#D8D8D8',
                                    width:2,
                                }
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#909399',
                                    fontSize:12
                                },
                            }
                        }
                    ],
                    yAxis: [
                        {show:false}
                    ],
                    series: [
                        {
                            name: '协访数',
                            type: 'bar',
                            barWidth: '30%',
                            data: [this.realNum,this.planNum, this.assessmentNum],
                            itemStyle:{
                                normal:{
                                    color:'#ff9901'
                                }
                            }
                        }
                    ]
                })

            },
            searchWeekList(){
                this.GLOBAL.date = this.date
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年MM月')
              debugger
                this.getData()
            },
            ResetClick(){
                this.date = ''
            },
            exportDataClick(){
                this.exportClick()
            },
            exportClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['日期', '协访人', '被协访人', '协访类型', '协访客户数','协访时长','协访评估已完成','计划内协访']
                        const filterVal = [
                            'activity_date',
                            'coach_name',
                            'coachee_name',
                            'category_type',
                            'clients',
                            'in_field',
                            'completed',
                            'status',
                        ]

                        const list = this.tableArray
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辅导/协访统计',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


        },

    }
</script>

<style scoped>
    #TutoringReport {
        background: #fff;
        height: 100%;
        box-sizing: border-box;
    }
    #TutoringReport >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #TutoringReport >>>.el-table th{
        padding: 7px 0px;
    }
    #TutoringReport >>>.el-table td{
        padding: 7px 0px;
    }
    #TutoringReport >>> .el-progress-bar__outer{
        border-radius: 2px;
        background-color: #909090;
    }
    #TutoringReport >>> .el-progress-bar__inner{
        border-radius: 2px;
    }



</style>



// WEBPACK FOOTER //
// src/pages/statement/components/TutoringReport.vue